
import { handleError, openNotificationWithIcon } from "appRedux/actions/Common";
import { config } from "constants/config";
import { useTheme } from "context/themeContext";
import { Formik } from "formik";
import React, { useState } from "react";
import DOMPurify from "dompurify";

import {
  Button,
  Form,
  FormGroup,
  InputGroup,
  Input,
  FormFeedback,
} from "reactstrap";
import LinkComponent from "routes/LinkComponent";
import { redirectDashboard } from "routes/RedirectRoutes";
import { useOperatorNavigate } from "utils/navigationHelper";
import api from "appRedux/api";

const TransactionLogin = () => {
  const [loading, setLoading] = useState(false);
  const { colorTheme, logoUrl, whiteLabelName } = useTheme();
  const navigate = useOperatorNavigate()

const redirectEmailPage = () => {
  navigate("/transactions/email")
}

  const submitHandler = async (data) => {
    setLoading(true);

    if (!data.email || !data.otp) {
      handleError("Email and OTP are required.");
      setLoading(false);
      return;
    }

    // Sanitize input to prevent injection
    const safeEmail = encodeURIComponent(data.email.trim());
    const safeOtp = encodeURIComponent(data.otp.trim());
    const safeWhiteLabel = encodeURIComponent(whiteLabelName?.trim() || "");

    const url = `${config.tokenUrl}/report/operator/whitelist/token?whitelabel=${safeWhiteLabel}&customerEmail=${safeEmail}&otp=${safeOtp}`;

    

    try {
      const response = await api.get(
        url,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
        config.tokenUrl 
      );
    
      
    
      localStorage.removeItem("credentials");
      localStorage.setItem(
        "credentials",
        JSON.stringify({
          email: data.email,
          token: data.otp,
          whiteLabel: whiteLabelName,
        })
      );
    
      openNotificationWithIcon("login successful");
    
      setTimeout(() => {
        navigate("/transactions");
      }, 2000);
    } catch (error) {
     
      const responseBody = error || error?.response?.data;
    
     
    
      const errorMessage =
        responseBody?.message ||
        responseBody?.error ||
        `Request failed with status ${error?.response?.status}`;
    
      console.error("Login Error:", errorMessage);
      handleError(errorMessage || "An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
    
  };

  return (
    <div className="main-section">
     <div className="topBar">
             <img
               src={DOMPurify.sanitize(logoUrl)}
               alt={`${whiteLabelName} logo`}
               style={{
                 width: "80px",
                 height: "auto",
                 objectFit: "fit",
                 maxHeight: "80px",
               }}
             />
             <div
               onClick={redirectDashboard}
               style={{ color: colorTheme, cursor: "pointer" }}
             >
               Go Home
             </div>
      </div>
      <main className="dashboard__main">
        <div className="dashboard_header">
          <h3 style={{ textAlign: "center", marginTop: "10px" }}>
            Get transport tickets transaction history.
          </h3>
        </div>
      </main>
      <div className="transaction_form_ontainer">
        <Formik
          initialValues={{
            email: "",
            otp: "",
          }}
          onSubmit={(values) => {
            const submitEmail = {
              email: values.email,
              otp: values.otp,
            };
            submitHandler(submitEmail);
          }}

          validate={(values) => {
            const errors = {};
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!values.email) {
              errors.email = "Email is required";
            }
            if (!values.otp) {
              errors.otp = "OTP is required";
            }
          
            if (!values.email) {
              errors.email = "Email is required";
            } else if (!emailRegex.test(values.email)) {
              errors.email = "Enter a valid email address";
            }
          
            return errors;
          }}
        
          render={({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            errors,
            touched,
            isValidating,
          }) => (
            <Form onSubmit={handleSubmit} style={{ width: "100%" }}>
              <FormGroup>
                <InputGroup className="mb-3">
                  <header className="mb-2">
                    <center>
                      Input your email address and OTP received to access your
                      transaction history
                    </center>
                  </header>

                  <Input
                    style={{
                      height: "45px",
                      borderRadius: "1px",
                      fontSize: "0.9rem",
                      width: "100%",
                      marginBottom: "2px",
                    }}
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    invalid={!!(errors.email && touched.email)}
                  />
                  {errors.email && touched.email && (
                    <FormFeedback>{errors.email}</FormFeedback>
                  )}
                </InputGroup>

                <InputGroup>
                  <Input
                    style={{
                      height: "45px",
                      borderRadius: "1px",
                      fontSize: "0.9rem",
                      width: "100%",
                      marginBottom: "6px",
                    }}
                    type="otp"
                    name="otp"
                    placeholder="OTP"
                    value={values.otp}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    invalid={!!(errors.otp && touched.otp)}
                  />
                  {errors.otp && touched.otp && (
                    <FormFeedback>{errors.otp}</FormFeedback>
                  )}
                </InputGroup>
              </FormGroup>

              <Button
                block
                style={{
                  height: "45px",
                  borderRadius: "1px",
                  fontSize: "0.9rem",
                  background: colorTheme,
                }}
                className="secondary-btn"
                onClick={handleSubmit}
                disabled={
                  isValidating ||
                  !values.email ||
                  !values.otp ||
                  loading ||
                  Object.keys(errors).length > 0
                }
              >
                {loading ? "Submitting..." : "Submit"}
              </Button>
              <br />

              <center>
                <p>
                  OTP expired or not yet recieved ?{" "}
                  <span style={{cursor:"pointer"}} onClick={redirectEmailPage}>Get OTP</span>
                  
                </p>
              </center>
            </Form>
          )}
        />
      </div>
    </div>
  );
};
export default TransactionLogin;
